import { impressionsViewsConfig } from '@/lib/analytics/kpis/instagram/impressionsViews';
import { SIZE_50 } from '@/lib/gridElements/size';

import { MediaViewerKpiLoader } from '@/components/base/Kpi/KpiLoader';
import { MediaViewerKPI } from '@/components/base/Kpi/MediaViewerKpi';

export const impressionsViewsMVConfig = {
    ...impressionsViewsConfig,
    name: 'kpi.instagram.mediaviewer.impressions_views',
    tooltip: null,
    mergedData: false,
    size: SIZE_50,
    loader: MediaViewerKpiLoader,
    element: MediaViewerKPI
};
